export const childrenFormatted = (children: any, required: boolean) => {
    return (
        <>
            {children} {renderRequiredIndicator(required)}
        </>
    );
};

const renderRequiredIndicator = (required: boolean) => {
    if (required) {
        return <span style={{ color: 'red' }}> *</span>;
    }
};
